import {
  Button,
  FormControlLabel,
  Grid,
  Link,
  Radio,
  RadioGroup,
  Typography
} from "@mui/material";
import MuiStack from "@mui/material/Stack";
import { useFormik } from "formik";
import { PropTypes } from "prop-types";
import Phone from "../../layouts/Phone";
import CustomInput from "../../components/CustomInput";

const Stack = (props) => (
  <MuiStack
    direction="row"
    justifyContent="space-between"
    spacing={2}
    {...props}
  />
);

const CustomTextarea = (props) => (
  <textarea
    style={{
      minHeight: 180,
      padding: 8,
      ...props.styles
    }}
    {...props}
  />
);

CustomTextarea.propTypes = {
  styles: PropTypes.object
};

export default function SmsCampaign() {
  const formik = useFormik({
    initialValues: {
      from: "",
      text: "Thank you for testing ORM SMS service. You will be able to change the content of your text message after adding funds."
    },
    onSubmit: (values) => {
      console.log(values);
    }
  });

  return (
    <div>
      <Typography variant="h3">New SMS Campaign</Typography>
      <Grid container spacing={0}>
        <Grid
          item
          xs={8}
          sx={{ backgroundColor: "white", borderRadius: 2, p: 2 }}
        >
          <form onSubmit={formik.handleSubmit} onChange={formik.handleChange}>
            <MuiStack spacing={2}>
              <Stack>
                <b>SMS from:</b>
                <div style={{ width: "80%" }}>
                  <CustomInput placeholder="Vendor" />
                </div>
              </Stack>
              <Stack>
                <b>SMS text:</b>
                <CustomTextarea
                  value={formik.values.text}
                  name="text"
                  styles={{ width: "80%" }}
                />
              </Stack>
              <Stack>
                <b>Recipients:</b>
                <div style={{ width: "80%" }}>
                  <select
                    style={{ width: "100%", height: 48, marginBottom: 16 }}
                  >
                    <option>Add manually</option>
                  </select>
                  <CustomTextarea
                    styles={{ width: "100%" }}
                    placeholder="Type or paste phone numbers, one number per line. Ypu can addd no more than 500 contacts"
                  />
                  <small>
                    You do not have any contacts yet.{" "}
                    <Link href="#">Upload some</Link>
                  </small>
                </div>
              </Stack>
              <Stack>
                <b>Send SMS:</b>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="immediately"
                  name="radio-buttons-group"
                  sx={{ width: "80%" }}
                >
                  <FormControlLabel
                    value="immediately"
                    control={<Radio />}
                    label="Immediately"
                  />
                  <FormControlLabel
                    value="later"
                    control={<Radio />}
                    label="Start sending SMS at"
                  />
                </RadioGroup>
              </Stack>
              <Stack justifyContent="end">
                <Button type="submit" variant="contained">
                  Send
                </Button>
              </Stack>
            </MuiStack>
          </form>
        </Grid>
        <Grid
          item
          xs={4}
          sx={{
            p: 2,
            backgroundColor: "#ccc",
            textAlign: "center"
          }}
        >
          Preview
          <Phone text={formik.values.text} sms />
        </Grid>
      </Grid>
    </div>
  );
}
